import { platformApiFetch } from '@/services/platformApi/client';
import { toast } from "sonner";
import { debugLogger } from '@/utils/debug';

/**
 * Sign up with email and password
 */
export const signUpWithEmailPassword = async (
  email: string, 
  password: string, 
  firstName: string, 
  lastName: string
) => {
  try {
    debugLogger.log("Signing up with data:", { 
      email, 
      firstName, 
      lastName
    });

    const data = await platformApiFetch<{ success: boolean; user?: unknown; requiresEmailConfirmation?: boolean }>('/v1/auth/sign-up', {
      method: 'POST',
      body: JSON.stringify({
        email,
        password,
        firstName,
        lastName,
      }),
    });

    toast.success("Account created", {
      description: data.requiresEmailConfirmation
        ? "Please check your email to confirm your account."
        : "Your account is ready and you have been signed in.",
    });

    return data;
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : 'Unknown error signing up';
    toast.error("Error signing up", {
      description: message,
    });
    throw error;
  }
};
